import React, { useEffect, useState } from 'react';
import { Row, Col, Card, CardBody } from 'reactstrap';
import { fetchImageCounts, fetchUploadCounts } from '../api/authApi';

export function Dashboard() {
  const [showAlert, setShowAlert] = useState(true);
  const [imageCounts, setImageCounts] = useState({
    unlabeled_count: 0,
    alert_count: 0,
    labeled_count: 0
  });
  const [uploadCounts, setUploadCounts] = useState({
    last_30_days: 0,
    last_60_days: 0,
    last_90_days: 0
  });

  useEffect(() => {
    const loadCounts = async () => {
      try {
        const imgCounts = await fetchImageCounts();
        setImageCounts(imgCounts);
      } catch (err) {
        console.error("Failed to fetch image counts:", err);
      }
      try {
        const upCounts = await fetchUploadCounts();
        setUploadCounts(upCounts);
      } catch (err) {
        console.error("Failed to fetch upload counts:", err);
      }
    };
    loadCounts();
  }, []);

  return (
    <div className="page-content">
      <Row>
        <Col xs={12}>
          <div className="page-title-box d-flex align-items-center justify-content-between">
            <h4 className="mb-0">Dashboard</h4>
          </div>
        </Col>
      </Row>
     
      <Row>
        {/* Image counts stats */}
        <Col md={4}>
          <Card>
            <CardBody>
              <div className="d-flex align-items-center">
                <div className="avatar-sm me-3">
                  <span className="avatar-title rounded-circle bg-soft-primary text-primary">
                    <i className="mdi mdi-image-multiple font-size-24"></i>
                  </span>
                </div>
                <h5 className="mb-0">Unaudited Images</h5>
              </div>
              <h4 className="mt-4 text-center">{imageCounts.unlabeled_count || 0}</h4>
            </CardBody>
          </Card>
        </Col>
        <Col md={4}>
          <Card>
            <CardBody>
              <div className="d-flex align-items-center">
                <div className="avatar-sm me-3">
                  <span className="avatar-title rounded-circle bg-soft-success text-success">
                    <i className="mdi mdi-check-circle-outline font-size-24"></i>
                  </span>
                </div>
                <h5 className="mb-0">Audited Images</h5>
              </div>
              <h4 className="mt-4 text-center">{imageCounts.labeled_count || 0}</h4>
            </CardBody>
          </Card>
        </Col>
        <Col md={4}>
          <Card>
            <CardBody>
              <div className="d-flex align-items-center">
                <div className="avatar-sm me-3">
                  <span className="avatar-title rounded-circle bg-soft-danger text-danger">
                    <i className="mdi mdi-alert-circle-outline font-size-24"></i>
                  </span>
                </div>
                <h5 className="mb-0">Alert Images</h5>
              </div>
              <h4 className="mt-4 text-center">{imageCounts.alert_count || 0}</h4>
            </CardBody>
          </Card>
        </Col>
      </Row>
      <Row className="mt-4">
        {/* Upload counts stats */}
        <Col md={4}>
          <Card>
            <CardBody>
              <div className="d-flex align-items-center">
                <div className="avatar-sm me-3">
                  <span className="avatar-title rounded-circle bg-soft-info text-info">
                    <i className="mdi mdi-clock-outline font-size-24"></i>
                  </span>
                </div>
                <h5 className="mb-0">Photos Uploaded (30 days)</h5>
              </div>
              <h4 className="mt-4 text-center">{uploadCounts.last_30_days || 0}</h4>
            </CardBody>
          </Card>
        </Col>
        <Col md={4}>
          <Card>
            <CardBody>
              <div className="d-flex align-items-center">
                <div className="avatar-sm me-3">
                  <span className="avatar-title rounded-circle bg-soft-warning text-warning">
                    <i className="mdi mdi-clock-outline font-size-24"></i>
                  </span>
                </div>
                <h5 className="mb-0">Photos Uploaded (60 days)</h5>
              </div>
              <h4 className="mt-4 text-center">{uploadCounts.last_60_days || 0}</h4>
            </CardBody>
          </Card>
        </Col>
        <Col md={4}>
          <Card>
            <CardBody>
              <div className="d-flex align-items-center">
                <div className="avatar-sm me-3">
                  <span className="avatar-title rounded-circle bg-soft-secondary text-secondary">
                    <i className="mdi mdi-clock-outline font-size-24"></i>
                  </span>
                </div>
                <h5 className="mb-0">Photos Uploaded (90 days)</h5>
              </div>
              <h4 className="mt-4 text-center">{uploadCounts.last_90_days || 0}</h4>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
}




